import { createSelector } from 'reselect';
export const selectModals = createSelector((state) => state.modals, modals => modals.modals);
export const selectIsModalOpen = (id) => {
    return createSelector(selectModals, modals => { var _a; return ((_a = modals.find((modal) => modal.id === id)) === null || _a === void 0 ? void 0 : _a.isOpen) || false; });
};
